import React from "react";

const AboutSection = () => {
  return (
    <>
      <section id="about" className="about-section">
        <div className="container">
          <h2 className="section-title" style={{ paddingBottom: "20px" }}>
            About FORMAX PAY
          </h2>
          <div className="about-content">
            <div className="about-text">
              <p>
                <strong>FORMAX PAY</strong> is a brand of{" "}
                <strong>FORMAX IT SOLUTIONS PRIVATE LIMITED</strong>, a
                registered Indian company, offering a simple and user-friendly
                platform for mobile recharge, DTH recharge, utility bill
                payments and Google Play recharge.
              </p>
              <p>
                Our focus is to provide a smooth and reliable experience by
                enabling users to complete their recharge and bill payments
                quickly and efficiently. The platform is designed with an
                emphasis on secure processing, transparent operations, and
                consistent performance, supported by dedicated customer
                assistance to ensure a seamless user experience.
              </p>
              <div className="legal-info">
                <p>
                  <strong>Legal Entity:</strong> FORMAX IT SOLUTIONS PRIVATE
                  LIMITED
                </p>
                <p>
                  <strong>CIN:</strong> U72900WB2018PTC228240 &nbsp;|&nbsp;
                  <strong>GSTIN:</strong> 19AADCF5125F1ZT
                </p>
                <p>
                  <strong>Registered Office:</strong> N0060, Mochpole, Near
                  Junior School, Nabapally, Barasat, Kolkata - 700126, West
                  Bengal, India
                </p>
              </div>
            </div>
            <div className="about-stats-card">
              <h3>
                <i className="fas fa-chart-line"></i> Why India trusts us
              </h3>
              <ul>
                <li>
                  <i className="fas fa-calendar-alt"></i> 5+ Years of Excellence
                </li>
                <li>
                  <i className="fas fa-headset"></i> 24/7 Customer Support
                </li>
                <li>
                  <i className="fas fa-bolt"></i> Instant Recharge & Bill Pay
                </li>
                <li>
                  <i className="fas fa-rupee-sign"></i> Upfront Discounts
                </li>
                <li>
                  <i className="fas fa-users"></i> 5L+ Happy Users
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Additional CSS for improved design */}
      <style>{`
        .about-section {
          background: #ffffff;
          padding: 60px 0;
        }
        .about-content {
          display: flex;
          flex-wrap: wrap;
          gap: 48px;
          margin-bottom: 60px;
        }
        .about-text {
          flex: 1.5;
          min-width: 260px;
        }
        .about-text p {
          margin-bottom: 20px;
          line-height: 1.6;
          color: #334155;
          font-size: 1rem;
        }
        .legal-info {
          background: #f1f5f9;
          padding: 20px;
          border-radius: 20px;
          margin-top: 20px;
        }
        .legal-info p {
          margin-bottom: 8px;
          font-size: 0.9rem;
        }
        .about-stats-card {
          flex: 1;
          background: linear-gradient(135deg, #1e40af, #2563eb);
          padding: 32px;
          border-radius: 32px;
          color: white;
          box-shadow: var(--shadow-md, 0 20px 25px -12px rgba(0,0,0,0.08));
        }
        .about-stats-card h3 {
          font-size: 1.5rem;
          margin-bottom: 24px;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .about-stats-card ul {
          list-style: none;
        }
        .about-stats-card li {
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 500;
          font-size: 1rem;
        }
        .about-stats-card li i {
          font-size: 1.2rem;
          width: 24px;
        }
        .mission-vision-row {
          display: flex;
          flex-wrap: wrap;
          gap: 32px;
          margin: 60px 0 50px;
        }
        .mission-card, .vision-card {
          flex: 1;
          background: white;
          padding: 32px;
          border-radius: 28px;
          text-align: center;
          box-shadow: var(--shadow-sm, 0 10px 25px -5px rgba(0,0,0,0.05));
          border: 1px solid #eef2ff;
          transition: transform 0.2s;
        }
        .mission-card:hover, .vision-card:hover {
          transform: translateY(-5px);
          box-shadow: var(--shadow-hover, 0 25px 30px -12px rgba(0,0,0,0.15));
        }
        .mission-card i, .vision-card i {
          font-size: 2.5rem;
          color: #1e40af;
          margin-bottom: 20px;
        }
        .mission-card h4, .vision-card h4 {
          font-size: 1.4rem;
          margin-bottom: 16px;
          color: #0f172a;
        }
        .mission-card p, .vision-card p {
          color: #475569;
          line-height: 1.5;
        }
        .values-section {
          text-align: center;
          margin-top: 20px;
        }
        .values-title {
          font-size: 1.8rem;
          margin-bottom: 32px;
          color: #0f172a;
        }
        .values-grid {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 24px;
        }
        .value-item {
          background: #f8fafc;
          padding: 14px 28px;
          border-radius: 60px;
          display: inline-flex;
          align-items: center;
          gap: 12px;
          font-weight: 600;
          color: #1e40af;
          border: 1px solid #e2e8f0;
          transition: all 0.2s;
        }
        .value-item i {
          font-size: 1.2rem;
        }
        .value-item:hover {
          background: #1e40af;
          color: white;
          border-color: #1e40af;
          transform: translateY(-2px);
        }
        @media (max-width: 720px) {
          .about-stats-card h3 { font-size: 1.3rem; }
          .mission-card h4, .vision-card h4 { font-size: 1.2rem; }
          .values-title { font-size: 1.5rem; }
          .value-item { padding: 10px 20px; font-size: 0.9rem; }
        }
      `}</style>
    </>
  );
};

export default AboutSection;
